export default "__VITE_ASSET__6OohGBT$__"